import React, { useEffect, useState } from "react";
import Text from "../../components/common/Text";
import { headers, tenzero, urlbase } from "../../constants/Constants";
import LoadingBox from "../Partials/LoadingBox";
import { useHistory } from "react-router-dom";
import axios from "axios";
import CircularProgress from "@mui/material/CircularProgress";
import { getAssignedTests } from "../../api/test";
import { Box, Typography } from "@mui/material";
import DescriptionIcon from "@mui/icons-material/Description";

export default function TestListAssignedContent(props) {
  props.user.key = 1;
  const user = props.user;
  const [tests, setTests] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [err, setErr] = useState(false);

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const spinnerStyle = {
    border: "16px solid #fbcd02",
    borderRadius: "50%",
    borderTop: "16px solid white",
    width: "60px",
    height: "60px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    animation: "spin 2s linear infinite",
  };

  const spinKeyframes = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;
  const history = useHistory();
  //Declarations
  let offset = 0;
  let requestCount = 0;

  useEffect(() => {
    setIsLoading(true);
    loadTests();
  }, []);

  const loadTests = async () => {
    const assignedTestsResponse = await getAssignedTests(user.token);

    if (assignedTestsResponse.code === 200) {
      const newTests = [];
      // assignedTestsResponse.message = undefined
      if (assignedTestsResponse.message !== undefined) {
        for (let i = 0; i < assignedTestsResponse.message.length; i++) {
          assignedTestsResponse.message[i].map((x) => {
            newTests.push(x);
          });
        }
      }
      setTests(newTests);

      setIsLoading(false);
    } else {
      setErr(true);
    }

    offset += 20;
    requestCount += 1;
  };

  offset += 20;
  requestCount += 1;

  // Check if the test start time is in the future
  function isTestLocked(test) {
    const testTime = test.grouptest.startTime;
    const date = new Date();
    const testTimeDate = new Date(testTime);
    // Return true if the current time is before the test start time
    return date < testTimeDate;
  }

  return (
    // app container

    <div
      style={{
        maxWidth: "100%",
        backgroundColor: "#212a41",
        padding: "15px",
        borderRadius: "5px",
        marginBottom: "20px",
      }}
    >
      <div
        style={{
          display: "flex",
          flexDirection: "column",
          width: windowWidth >= 800 ? "100%" : "100%",
          alignContent: "center",
          justifyItems: "center",
        }}
      >
        <div>
          <div
            style={{
              backgroundColor: "#212a41",
              borderRadius: "5px",
              marginBottom: "10px",
            }}
          >
            <Typography
              variant="h6"
              style={{
                fontWeight: "bold",
                color: "#fbcd02",
                padding: "5px",
                textAlign: "left",
                marginBottom: "5px",
                fontSize: "1.1rem",
              }}
            >
              Assigned Tests
            </Typography>

            <hr
              style={{
                marginBottom: "20px",
                borderColor: "#FBCD02",
                borderWidth: "1px",
                borderStyle: "solid",
                width: "100%",
              }}
            />

            <div
              style={{
                maxHeight: "300px",
                overflowY: "scroll",
                overflowX: "hidden",
                maxWidth: "100%",
                scrollbarColor: "#fbcd02 #212a41",
              }}
            >
              {/* Error Loading Tests */}
              {err ? (
                <div style={{ color: "white" }}>Error Loading Tests</div>
              ) : isLoading ? (
                <CircularProgress sx={{ color: "white" }} />
              ) : tests.length === 0 ? (
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    height: "100%",
                    color: "white",
                    "@keyframes fadeIn": {
                      from: { opacity: 0 },
                      to: { opacity: 1 },
                    },
                    animation: "fadeIn 2s ease-in-out",
                  }}
                >
                  <DescriptionIcon
                    sx={{
                      fontSize: 40,
                      marginBottom: 2,
                      animation: "fadeIn 2s ease-in-out",
                    }}
                  />
                  <Typography
                    sx={{
                      textAlign: "center",
                      fontWeight: "bold",
                      animation: "fadeIn 2s ease-in-out",
                    }}
                  >
                    No Assigned Tests Found
                  </Typography>
                </Box>
              ) : (
                tests.map((item, i) => (
                  <div key={i}>
                    {/* Render the unclickable card if the test is locked */}
                    {isTestLocked(item) ? (
                      <div
                        className={"unClickReferenceCard"}
                        style={{
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: "darkgrey",
                          backgroundColor: "lightgrey",
                          color: "#darkgrey",
                          width: "100%",
                          borderRadius: "5px",
                          marginBottom: "10px",
                          fontSize: "0.8rem",
                          fontWeight: "bold",
                          textAlign: "left",
                        }}
                      >
                        <div>
                          {item.grouptest.startTime +
                            " - " +
                            item.grouptest.endTime}
                        </div>
                        <div>{item.test.name}</div>
                      </div>
                    ) : (
                      <div
                        className={"ReferenceCard"}
                        style={{
                          borderWidth: "1px",
                          borderStyle: "solid",
                          borderColor: "#00112e",
                          backgroundColor: "white",
                          color: "#428BC6",
                          width: "100%",
                          borderRadius: "5px",
                          marginBottom: "10px",
                          fontSize: "0.8rem",
                          fontWeight: "bold",
                        }}
                        onClick={() =>
                          history.push("/teststart", {
                            user: user,
                            grouptest: item.grouptest,
                            test: item.test,
                          })
                        }
                      >
                        <div>
                          {item.grouptest.startTime +
                            " - " +
                            item.grouptest.endTime}
                        </div>
                        <div>{item.test.name}</div>
                      </div>
                    )}
                  </div>
                ))
              )}
              {tests.length > 0 && !isLoading && (
                <div
                  style={{
                    color: "white",
                    marginTop: "20px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  No More Assigned Tests Found
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
